import { c as _c } from "react/compiler-runtime";
import { ensureScript } from '@/utils/ensureScript';
import { useEffect, useState } from 'react';
export default function useScript(src) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loaded: false,
      error: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== src) {
    t1 = () => {
      ensureScript(src).then(() => {
        setState({
          loaded: true,
          error: false
        });
      }).catch(() => {
        setState({
          loaded: true,
          error: true
        });
      });
    };
    t2 = [src];
    $[1] = src;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== state.error || $[5] !== state.loaded) {
    t3 = [state.loaded, state.error];
    $[4] = state.error;
    $[5] = state.loaded;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}